import analyticsSaga from './analytics/sagas';
import userSaga from './user/saga';
//TODO plugin a web error reporting
export const applicationSagas = [analyticsSaga, userSaga];
